export interface IScrollbarWidth {
    (force?: boolean): number | undefined;
    __cache?: number;
}

export const scrollbarWidth: IScrollbarWidth = (force?: boolean): number | undefined => {
    // check for SSR
    if (typeof document === 'undefined') {
        return 0;
    }

    // return cached value if we have some
    if (force !== true && typeof scrollbarWidth.__cache === 'number') {
        return scrollbarWidth.__cache;
    }

    const el = document.createElement('div');
    const { style } = el;

    style.display = 'block'; // for the case of weird css rules where div will not be a block element.
    style.position = 'absolute';
    style.width = '100px';
    style.height = '100px';
    style.left = '-999px';
    style.top = '-999px';
    style.overflow = 'scroll';

    document.body.insertBefore(el, null);

    const { clientWidth } = el;

    // if element still has no width it means DOM is not ready yet
    if (clientWidth === 0) {
        // remove the element and skip the caching
        document.body.removeChild(el);
        return undefined;
    }

    // clientWidth is the total width of the block - scrollbar width, thus, to get the scrollbar width
    scrollbarWidth.__cache = 100 - clientWidth;

    document.body.removeChild(el);

    return scrollbarWidth.__cache;
};
